import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface RequireAuthProps {
  children: JSX.Element;
  requiredRoles?: string[];
}

export const RequireAuth: React.FC<RequireAuthProps> = ({ children, requiredRoles }) => {
  const { currentUser, auth, roles, isAdmin } = useAuth();
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    auth.authStateReady().then(() => {
      setAuthReady(true);
    });
  }, [auth]);

  if (!authReady) {
    return <div className="flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <ProgressSpinner />
    </div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // If specific roles are required, validate them (admins bypass)
  if (requiredRoles && requiredRoles.length > 0 && !isAdmin) {
    const userRoles = roles ?? [];
    const hasRole = requiredRoles.some(r => userRoles.includes(r));
    if (!hasRole) {
      // Not authorized for the requested route — redirect to tokens (minimal access)
      return <Navigate to="/tokens" />;
    }
  }

  return children;
};
